import { render, staticRenderFns } from "./dashboard_view.vue?vue&type=template&id=12a956ef&scoped=true&"
import script from "./dashboard_view.vue?vue&type=script&lang=js&"
export * from "./dashboard_view.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_view.vue?vue&type=style&index=0&id=12a956ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a956ef",
  null
  
)

export default component.exports